import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}pub/`;
export const AUTH_TOKEN_KEY = 'authToken';

const $api = axios.create({
    baseURL: API_URL,
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});

const $refreshApi = axios.create({
    baseURL: API_URL,
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true
});

let refreshPromise = null;

export const getAuthToken = () => {
    return localStorage.getItem(AUTH_TOKEN_KEY);
};

export const setAuthToken = (token) => {
    if (!token) {
        return;
    }
    localStorage.setItem(AUTH_TOKEN_KEY, token);
};

export const clearAuthToken = () => {
    localStorage.removeItem(AUTH_TOKEN_KEY);
};

export const extractAuthToken = (payload) => {
    if (!payload) {
        return null;
    }

    return payload.authToken
        || payload.accessToken
        || payload.token
        || payload?.data?.authToken
        || payload?.data?.accessToken
        || payload?.data?.token
        || null;
};

const refreshAuthToken = async () => {
    if (refreshPromise) {
        return refreshPromise;
    }

    refreshPromise = $refreshApi
        .post('/kb/auth/refresh')
        .then((res) => {
            const token = extractAuthToken(res?.data);
            if (token) {
                setAuthToken(token);
                return token;
            }
            clearAuthToken();
            return null;
        })
        .catch((err) => {
            clearAuthToken();
            throw err;
        })
        .finally(() => {
            refreshPromise = null;
        });

    return refreshPromise;
};

$api.interceptors.request.use((config) => {
    const token = getAuthToken();
    if (!token) {
        return config;
    }

    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
    return config;
});

$api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error?.config;
        const status = error?.response?.status;

        if (!originalRequest || status !== 401 || originalRequest._retry) {
            return Promise.reject(error);
        }

        if (originalRequest.url === '/kb/auth/refresh') {
            clearAuthToken();
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        try {
            const refreshedToken = await refreshAuthToken();
            if (refreshedToken) {
                originalRequest.headers = originalRequest.headers || {};
                originalRequest.headers.Authorization = `Bearer ${refreshedToken}`;
            }
            return $api(originalRequest);
        } catch (refreshError) {
            return Promise.reject(refreshError);
        }
    }
);

export default $api;
